"use strict";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TranslationsProvider = void 0;
var _fetching = require("@ori/fetching");
var _react = require("react");
var _reactIntl = require("react-intl");
var _constants = require("../../internals/constants");
var _logger = require("../../logger");
var _utils = require("../../utils");
var _translationsContext = require("./translationsContext");
var _utils2 = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
var logger = _logger.mainLogger.createChild('TranslationsProvider');
var handleIntlProviderError = function(err) {
    var _err_descriptor_id, _err_descriptor;
    if (err.code === _reactIntl.ReactIntlErrorCode.MISSING_DATA) {
        logger.info(err.message);
        return;
    }
    if (err.code === _reactIntl.ReactIntlErrorCode.FORMAT_ERROR) {
        logger.warn(err.message);
        return;
    }
    if (err.code === _reactIntl.ReactIntlErrorCode.MISSING_TRANSLATION && ((_err_descriptor = err.descriptor) === null || _err_descriptor === void 0 ? void 0 : (_err_descriptor_id = _err_descriptor.id) === null || _err_descriptor_id === void 0 ? void 0 : _err_descriptor_id.includes(_constants.DYNAMIC_TRANSLATION_PREFIX))) {
        return;
    }
    throw err;
};
/**
 * Provider which provides translations context and internationalization for its children.
 * @returns Rendered component with translations context and internationalization provided.
 */ var TranslationsProvider = function(param) {
    var translationsWithNamespaces = param.translationsWithNamespaces, defaultTranslationsWithNamespaces = param.defaultTranslationsWithNamespaces, currentLanguage = param.currentLanguage, language = param.language, clientFetchConfiguration = param.clientFetchConfiguration, children = param.children;
    var _ref;
    var usedLanguage = (_ref = language !== null && language !== void 0 ? language : currentLanguage) !== null && _ref !== void 0 ? _ref : '';
    var fallbackLocale = usedLanguage ? usedLanguage.slice(0, 2) : 'en';
    /**
   * Determines whenever data is needed to be fetch on client or not.
   */ var shouldFetch = (0, _react.useMemo)(function() {
        return !translationsWithNamespaces && clientFetchConfiguration && (!!clientFetchConfiguration.baseUrl || typeof window !== 'undefined');
    }, [
        clientFetchConfiguration,
        translationsWithNamespaces
    ]);
    /**
   * Fetches localization data in standalone apps using SWR with provided options.
   */ var _ref1 = (0, _fetching.useSWR)(shouldFetch ? [
        usedLanguage,
        clientFetchConfiguration === null || clientFetchConfiguration === void 0 ? void 0 : clientFetchConfiguration.tenant,
        defaultTranslationsWithNamespaces
    ] : null, /*#__PURE__*/ _async_to_generator(function() {
        var _clientFetchConfiguration_baseUrl;
        return _ts_generator(this, function(_state) {
            return [
                2,
                clientFetchConfiguration ? (0, _utils.fetchTranslationsWithNamespaces)({
                    clientFetchConfiguration: {
                        baseUrl: (_clientFetchConfiguration_baseUrl = clientFetchConfiguration.baseUrl) !== null && _clientFetchConfiguration_baseUrl !== void 0 ? _clientFetchConfiguration_baseUrl : window.location.origin,
                        tenant: clientFetchConfiguration.tenant
                    },
                    language: usedLanguage,
                    defaultTranslationsWithNamespaces: defaultTranslationsWithNamespaces,
                    onError: clientFetchConfiguration.onError
                }) : null
            ];
        });
    }), {
        fallbackData: {
            translationsWithNamespaces: translationsWithNamespaces !== null && translationsWithNamespaces !== void 0 ? translationsWithNamespaces : defaultTranslationsWithNamespaces
        },
        suspense: true,
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        shouldRetryOnError: false,
        revalidateOnMount: true
    }), localizationData = _ref1.data;
    var _localizationData_translationsWithNamespaces;
    /**
   * Determines the data to use for the translations context.
   */ var data = (_localizationData_translationsWithNamespaces = localizationData === null || localizationData === void 0 ? void 0 : localizationData.translationsWithNamespaces) !== null && _localizationData_translationsWithNamespaces !== void 0 ? _localizationData_translationsWithNamespaces : translationsWithNamespaces;
    var showTranslationKeys = typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('_showTranslationKeys');
    var contextValue = (0, _react.useMemo)(function() {
        return {
            translationsWithNamespaces: showTranslationKeys && data ? (0, _utils2.mapNamespacedTranslations)(data, _utils2.mapTranslationsToKeys) : data,
            defaultTranslationsWithNamespaces: showTranslationKeys ? (0, _utils2.mapNamespacedTranslations)(defaultTranslationsWithNamespaces, _utils2.mapTranslationsToKeys) : defaultTranslationsWithNamespaces,
            currentLanguage: usedLanguage,
            language: usedLanguage,
            clientFetchConfiguration: clientFetchConfiguration !== null && clientFetchConfiguration !== void 0 ? clientFetchConfiguration : undefined,
            showTranslationKeys: showTranslationKeys
        };
    }, [
        data,
        defaultTranslationsWithNamespaces,
        usedLanguage,
        clientFetchConfiguration,
        showTranslationKeys
    ]);
    var reactIntlData = (0, _utils2.flattenAndConcatenateKeysWithNamespace)(data ? showTranslationKeys ? (0, _utils2.mapNamespacedTranslations)(data, _utils2.mapTranslationsToKeys) : data : {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_translationsContext.translationsContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactIntl.IntlProvider, {
            locale: usedLanguage,
            defaultLocale: fallbackLocale,
            messages: reactIntlData,
            onError: handleIntlProviderError,
            children: children
        })
    });
};
exports.TranslationsProvider = TranslationsProvider; //# sourceMappingURL=TranslationsProvider.js.map
